var _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 796,
    height: 714,
    viewBox: "0 0 796 714",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5284_6)",
    filter: "url(#filter0_d_5284_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5284_6",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 796,
    height: 714
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M796 0H0V714H796V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5284_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5284_6",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -106,
    width: 3459,
    height: 3837
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-216 -106H3243V3731H-216V-106Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5284_6)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.439 355.146L485.599 140.168L111.439 355.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.439 355.146L485.599 140.168",
    stroke: "#623CE7",
    strokeWidth: 92.0138,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.439 496.146L574.599 281.168L200.439 496.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.439 496.146L574.599 281.168",
    stroke: "#623CE7",
    strokeWidth: 92.0138,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M670.439 227.146L699.6 210.17L670.439 227.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.439 227.146L699.6 210.17",
    stroke: "#623CE7",
    strokeWidth: 92.0138,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.439 612.146L616.599 446.169L332.439 612.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.439 612.146L616.599 446.169",
    stroke: "#623CE7",
    strokeWidth: 92.0138,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M686.106 462.388C690.657 462.866 693.964 466.949 693.485 471.5C693.007 476.051 688.924 479.357 684.373 478.879C679.823 478.4 676.516 474.317 676.994 469.767C677.473 465.216 681.556 461.91 686.106 462.388Z",
    stroke: "#623CE7",
    strokeWidth: 4.28355
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4 631.173C209.883 631.959 215.32 638.673 214.534 646.157C213.747 653.64 207.033 659.077 199.55 658.291C192.066 657.504 186.629 650.79 187.416 643.306C188.202 635.823 194.917 630.386 202.4 631.173Z",
    stroke: "#623CE7",
    strokeWidth: 7.044
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.571 72.3501C401.054 73.1366 406.491 79.851 405.705 87.3342C404.918 94.8174 398.204 100.255 390.721 99.4681C383.237 98.6816 377.8 91.9672 378.587 84.484C379.373 77.0008 386.088 71.5636 393.571 72.3501Z",
    stroke: "#623CE7",
    strokeWidth: 7.044
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7071 249.901C81.1446 249.901 83.9356 252.692 83.9356 256.129C83.9356 259.567 81.1446 262.358 77.7071 262.358C74.2695 262.358 71.4785 259.567 71.4785 256.129C71.4785 252.692 74.2695 249.901 77.7071 249.901Z",
    stroke: "#623CE7",
    strokeWidth: 5.14888
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.471 656.074C564.908 656.074 567.7 658.865 567.7 662.303C567.7 665.741 564.908 668.532 561.471 668.532C558.033 668.532 555.242 665.741 555.242 662.303C555.242 658.865 558.033 656.074 561.471 656.074Z",
    stroke: "#623CE7",
    strokeWidth: 5.14888
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.228 70.3242L639.953 46.5477",
    stroke: "#623CE7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.594 54.7531L648.37 62.4785",
    stroke: "#623CE7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.642 478.453L109.533 454.421",
    stroke: "#623CE7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4697 463.158L118.501 470.049",
    stroke: "#623CE7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.273 586.619L627.896 562.26",
    stroke: "#623CE7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.311 571.772L637.67 577.396",
    stroke: "#623CE7",
    strokeWidth: 3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398.111 177.281C497.315 177.281 577.861 257.827 577.861 357.031C577.861 456.235 497.315 536.781 398.111 536.781C298.907 536.781 218.361 456.235 218.361 357.031C218.361 257.827 298.907 177.281 398.111 177.281Z",
    fill: "#623CE7",
    fillOpacity: 0.26
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398 194.281C487.822 194.281 560.75 267.209 560.75 357.031C560.75 446.853 487.822 519.781 398 519.781C308.178 519.781 235.25 446.853 235.25 357.031C235.25 267.209 308.178 194.281 398 194.281Z",
    fill: "#623CE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 363L368.5 406L471.5 303",
    stroke: "white",
    strokeWidth: 18
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5284_6",
    x: -4,
    y: 0,
    width: 804,
    height: 722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5284_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5284_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5284_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 796,
    height: 714,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMark);
export default __webpack_public_path__ + "static/media/tick-mark.80cb149b2f571f024dd46c55f1e02078.svg";
export { ForwardRef as ReactComponent };